export const SPORT_GROUPS = [
  {
    id: 'court-field',
    label: 'Court & Field Sports',
    sports: [
      ['pickleball', 'Pickleball'],
      ['tennis', 'Tennis'],
      ['basketball', 'Basketball'],
      ['soccer', 'Soccer'],
      ['volleyball', 'Volleyball'],
      ['badminton', 'Badminton'],
      ['spikeball', 'Spikeball'],
      ['street hockey', 'Street Hockey'],
      ['lacrosse', 'Lacrosse'],
      ['flag football', 'Flag Football'],
      ['kickball', 'Kickball'],
      ['racquetball', 'Racquetball'],
      ['squash', 'Squash'],
      ['disc golf', 'Disc Golf'],
      ['dodgeball', 'Dodgeball'],
    ],
  },
  {
    id: 'table-precision',
    label: 'Precision & Table Games',
    sports: [
      ['ping pong', 'Ping Pong'],
      ['pool', 'Pool'],
      ['darts', 'Darts'],
      ['foosball', 'Foosball'],
      ['air hockey', 'Air Hockey'],
      ['bowling', 'Bowling'],
      ['pinball', 'Pinball'],
      ['shuffleboard', 'Shuffleboard'],
      ['beer pong', 'Beer Pong'],
      ['jenga', 'Jenga'],
      ['checkers', 'Checkers'],
      ['chess', 'Chess'],
      ['tic tac toe', 'Tic Tac Toe'],
    ],
  },
  {
    id: 'park-backyard',
    label: 'Park & Backyard Games',
    sports: [
      ['cornhole', 'Cornhole'],
      ['bocce', 'Bocce'],
      ['ladder toss', 'Ladder Toss'],
      ['horseshoes', 'Horseshoes'],
    ],
  },
  {
    id: 'gym-performance',
    label: 'Gym Performance',
    sports: [
      ['weightlifting', 'Weightlifting'],
      ['crossfit', 'CrossFit'],
      ['hyrox', 'HYROX'],
    ],
  },
  {
    id: 'foot-race',
    label: 'Foot Races',
    sports: [
      ['sprint 100-400m', 'Sprint (100-400m)'],
      ['1 mile', '1 Mile Run'],
    ],
  },
  {
    id: 'trick-style',
    label: 'Action Sports',
    sports: [
      ['skateboarding', 'Skateboarding'],
      ['bmx flatground', 'BMX'],
      ['scooter', 'Scooter'],
      ['inline tricks', 'Blading'],
      ['rock climbing', 'Rock Climbing'],
      ['parkour', 'Parkour'],
      ['chase tag', 'Chase Tag'],
      ['breakdancing', 'Breakdancing'],
    ],
  },
  {
    id: 'combat',
    label: 'Combat Sports',
    sports: [
      ['friendly sparring', 'Sparring'],
      ['arm wrestle', 'Arm Wrestling'],
    ],
  },
] as const;

export type SportGroupId = (typeof SPORT_GROUPS)[number]['id'];
export type SportId = (typeof SPORT_GROUPS)[number]['sports'][number][0];

export const SPORTS = SPORT_GROUPS.flatMap((group) => group.sports.map(([id]) => id)) as SportId[];

const SPORT_LABELS = new Map<string, string>(
  SPORT_GROUPS.flatMap((group) => group.sports.map(([id, label]) => [id, label] as const)),
);
const SPORT_CATEGORIES = new Map<string, SportGroupId>(
  SPORT_GROUPS.flatMap((group) => group.sports.map(([id]) => [id, group.id] as const)),
);
const LOWER_TO_SPORT = new Map<string, SportId>(SPORTS.map((sport) => [sport.toLowerCase(), sport]));

function startCase(value: string) {
  return value.replace(/\b\w/g, (letter) => letter.toUpperCase());
}

export function normalizeSportId(value: unknown): SportId | null {
  if (typeof value !== 'string') return null;
  return LOWER_TO_SPORT.get(value.trim().toLowerCase()) ?? null;
}

export function getSportLabel(id: SportId | string): string {
  return SPORT_LABELS.get(id) ?? startCase(id);
}

export function getSportCategoryId(id: SportId | string | null | undefined): SportGroupId | null {
  if (!id) return null;
  return SPORT_CATEGORIES.get(id) ?? null;
}
